export default __webpack_public_path__ + "static/media/astra-world.285aae16.svg";